export const toastMessages = {
  endTimeBeforeStartTime: "End time must be after start time",
  endTimeNot30MinutesAfterStartTime:
    "End time must be at least 30 minutes after start time",
};
